type RowProps = {
  title?: string
  alignCenter?: boolean
  dateTime?: string
  rightContent?: React.ReactNode
}

export const Row = ({
  title,
  dateTime,
  alignCenter,
  rightContent,
}: RowProps) => {
  return (
    <>
      <div className="grid">
        <div
          className={`grid-column left ${alignCenter ? 'align-center' : ''}`}
        >
          {title && <h4 className="title">{title}</h4>}
          {dateTime && <span>{dateTime}</span>}
        </div>
        <div className="grid-column right">{rightContent}</div>
      </div>
    </>
  )
}
